/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_EDITBUTTONNAME,EDITBUTTONNAME_RECEIVED } = constants.EditButtonNameConstant;

export default {
    REQUEST_EDITBUTTONNAME,
    EDITBUTTONNAME_RECEIVED,

  requestEditVideoNoteNote: payload => ({
    type: REQUEST_EDITBUTTONNAME,
    payload
  }),
  EditVideoNoteReceived: () => ({
    type: EDITBUTTONNAME_RECEIVED
  }),
};
